import { underscoreTemplateGrindex } from "@grindex-client/common/js/helpers/underscore-helper";
import { resolveApiUrl } from "@grindex-common/helpers/apiUrlResolver";
const LABELS = "abcdefghijklmnopqrstuvwxyz";

class LocationResults {
	constructor(options) {
		const $inputField = document.getElementById("query");
		this.getDistanceUnit = options.getDistanceUnit;
		this.$searchResultsContainer = document.getElementsByClassName("listResultsContainer")[0];
		this.$searchFeedback = document.getElementsByClassName("search-feedback")[0];
		this.$middleContentArea = document.getElementsByClassName("middle-content-area")[0];
		this.$errorMessage = document.getElementsByClassName("error-msg")[0];

		this.locationTemplate = underscoreTemplateGrindex($("#location-result-tmpl").html());
		this.autocomplete = new google.maps.places.Autocomplete($inputField);
	}

	search(parameters, callBack) {
		const url = resolveApiUrl("api/location/searchlocations", parameters);

		fetch(url)
			.then((response) => response.json())
			.then((res) => {
				this.renderLocations(res);

				if (callBack) {
					callBack(res.Facets);
				}
			})
			.catch((err) => {
				this.showNoResults();
				throw new Error("location search error, response: " + err);
			});
	}

	renderLocations(data) {
		if (data.Items.length > 0) {
			this.showResults();
		} else {
			this.showNoResults();
			return;
		}

		let count = 0;
		let locationHtml = "";
		this.$searchResultsContainer.innerHTML = "";

		data.Items.forEach((location) => {
			let locationLetter = LABELS.charAt(count);
			locationHtml += this.renderLocation(location, locationLetter);
			count += 1;
		});

		this.$searchResultsContainer.innerHTML = locationHtml;
	}

	renderLocation(location, locationLetter) {
		return this.locationTemplate({
			Unit: this.getDistanceUnit().label,
			MarkerLetter: locationLetter,
			...location,
		});
	}

	hideElement($element) {
		$element.classList.add("hidden");
	}

	showElement($element) {
		$element.classList.remove("hidden");
		if ($element.style.display === "none") {
			$element.style.display = "block";
		}
	}

	showResults() {
		this.hideElement(this.$errorMessage);
		this.showElement(this.$searchFeedback);
		this.showElement(this.$middleContentArea);
		this.showElement(this.$searchResultsContainer);
	}

	showNoResults() {
		this.showElement(this.$errorMessage);
		this.showElement(this.$searchFeedback);
		this.showElement(this.$middleContentArea);
		this.hideElement(this.$searchResultsContainer);
	}
}

export { LocationResults };
